import React from "react";
import styled from "@emotion/styled";

import MuiTextField from "@mui/material/TextField";

import ParkkiTheme from "themes/ParkkiTheme";

const StyledTextField = styled(MuiTextField)`
  color: ${ParkkiTheme.colors.white};
  opacity: 0.85;

  input {
    color: ${ParkkiTheme.colors.white};
    opacity: ".85";
  }

  label {
    color: ${ParkkiTheme.colors.white};
    opacity: ".85";
  }
  label.Mui-focused {
    color: ${ParkkiTheme.colors.white};
    opacity: ".85";
  }
  .MuiInput-underline {
    border-bottom: 1px solid ${ParkkiTheme.colors.white};
  }
  .MuiInput-underline:after {
    border-bottom: 1px solid ${ParkkiTheme.colors.turquoise};
  }
`;

type Props = {
  disabled: boolean;
  error: boolean;
  fullWidth: boolean;
  helperText: string;
  label: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  type: string;
};

function TextField({
  disabled,
  error,
  fullWidth,
  helperText,
  label,
  onClick,
  value,
  onChange,
  type,
}: Props): JSX.Element {
  return (
    <StyledTextField
      variant="standard"
      error={error}
      fullWidth={fullWidth}
      label={label}
      type={type}
      onChange={onChange}
      helperText={helperText}
      onClick={onClick}
      disabled={disabled}
      value={value}
    />
  );
}

TextField.defaultProps = {
  error: false,
  fullWidth: false,
  helperText: "",
  onClick: null,
};

export default TextField;
